const en = {
	loginTitle: 'please login',
	account: 'account',
	password: 'password',
	input: 'please Input',
	phoneNum: 'phone',
	plInputPassword: 'please enter password',
	forgetPassword: 'forget forget',
	wrongPassword: 'wrong account or password',
	plPhoneCode: 'please enter the mobile phone verification code',
	plGraphicCode: 'please enter the graphic verification code',
	plCorrGraphicCode: 'please enter the correct graphic verification code',
	login: 'login',
	cancel: 'cancel',
	reset: 'reset',
	next: 'next',
	goLogin: 'login',
	verifiCode: 'verifi code',
	phone: 'phone',
	resetPassword: 'reset password',
	SMSCode: 'SMS code',
	getCode: 'get code',
	get: 'get',
	second: 'second',
	backLogin: 'background management login',
	centralServer: 'central server',
	confirmPassword: 'confirm password',
};
export default en;
